import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer website design services in Vijayawada?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide expert website design, development, SEO, and e-commerce solutions tailored for businesses in Vijayawada."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of website development in Vijayawada?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our website packages start from ₹10,000. Final pricing depends on design complexity, features, and number of pages."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all websites we design are mobile-friendly and optimized for seamless performance across all devices."
      }
    },
    {
      "@type": "Question",
      "name": "Is SEO included in your web design services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we incorporate on-page SEO elements like meta tags, schema markup, fast loading speeds, and clean URLs."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update my website content myself?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. We build websites using CMS platforms like WordPress, so you can easily manage and update your content."
      }
    },
    {
      "@type": "Question",
      "name": "Do you build e-commerce websites in Vijayawada?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we develop e-commerce websites with product listings, shopping carts, secure payment gateways, and order tracking."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to complete a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Typically, a basic website takes 5–10 working days. Complex or e-commerce sites may take 2–4 weeks."
      }
    },
    {
      "@type": "Question",
      "name": "Do you assist with domain registration and hosting?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we help with domain registration, hosting setup, SSL certificates, and business email configuration."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide website maintenance services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer maintenance packages including regular updates, backups, security checks, and technical support."
      }
    },
    {
      "@type": "Question",
      "name": "How do I start a website project with you in Vijayawada?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can contact us via phone or our website. We will understand your requirements and begin your project promptly."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Vijayawada</title>
<meta name="description" content="Top website designer in Vijayawada. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="website designing company in Vijayawada, website developer in Vijayawada, senior website developer, web development company in Vijayawada, website maker in Vijayawada, website design company, pankaj web designer, pankj, freelance website designer, website designer in Vijayawada, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Vijayawada" />
<meta property="og:description" content="Top Website Designer In Vijayawada. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Vijayawada" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-vijayawada"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Vijayawada" />
<meta name="twitter:description" content="Top website designer in Vijayawada. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-vijayawada" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer in Vijayawada</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Vijayawada</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Looking to establish a strong online presence with a professionally designed website? I’m Pankaj, an experienced website designer dedicated to helping businesses and individuals in Vijayawada bring their digital ideas to life with creative, responsive, and SEO-friendly website designs.
<h3>Why Choose Pankaj as Your Website Designer in Vijayawada?</h3>
<ol>
  <li><strong>Custom-Tailored Designs for Every Client</strong>
I believe that every brand has a unique story to tell. Whether you’re looking for a corporate website, an e-commerce store, a blog, or a personal portfolio, I work closely with you to design a website that aligns perfectly with your brand and goals.</li>
  <li><strong>SEO-Optimized for Higher Visibility</strong>
A well-designed website should also attract visitors. I incorporate SEO best practices to help your website rank better on search engines, making it easier for potential customers to find you online.</li>
  <li><strong>Full-Service Design and Development</strong>
From initial concept to final launch, I provide a comprehensive range of website design services, including development, redesign, and e-commerce solutions. Using popular CMS platforms like WordPress, I make sure you can easily manage your content once your website is live.</li>
  <li><strong>Clear Communication and Ongoing Support</strong>
Transparency and communication are at the core of my process. I provide clear project timelines, transparent pricing, and ongoing maintenance and support to keep your website secure and functional.</li>
</ol>
<h3>Services Offered</h3>
<ul>
  <li><strong>Custom Website Design &amp; Redesign</strong>
Unique designs that focus on user experience, tailored to showcase your brand’s strengths and values.</li>
  <li><strong>E-commerce Website Development</strong>
Secure and user-friendly e-commerce sites that help drive sales and provide a seamless shopping experience for your customers.</li>
  <li><strong>Corporate and Personal Websites</strong>
Professional websites that enhance your online presence and engage your target audience effectively.</li>
  <li><strong>Basic SEO and Digital Marketing</strong>
All websites are created with core SEO principles in mind. For more advanced digital marketing needs, I work with trusted partners to provide specialized services.</li>
</ul>
<h3>Ready to Build a Strong Online Presence?</h3>
Contact me today to discuss your project. Let’s create a website that not only represents your brand in Vijayawada but also sets you apart in today’s digital landscape.
<h2>Frequently Asked Questions</h2>

<h4>What types of websites does Pankaj design in Vijayawada?</h4>
<p>Pankaj designs various types of websites, including corporate sites, e-commerce stores, personal blogs, and portfolios. Each design is customized to reflect the client’s brand identity and achieve specific business objectives.</p>

<h4>Why should I choose Pankaj as my website designer?</h4>
<p>Pankaj brings years of experience and a client-focused approach to each project, delivering high-quality, responsive, and SEO-friendly websites that provide an exceptional user experience. His designs are crafted to help brands stand out and grow online.</p>

<h4>Does Pankaj provide SEO services?</h4>
<p>Yes, Pankaj incorporates essential SEO best practices in each website design to boost search engine visibility. For advanced SEO and digital marketing needs, he collaborates with reliable experts in the field.</p>

<h4>What is the cost of a website design project?</h4>
<p>The cost of a website design project depends on its complexity, features, and requirements. Pankaj provides a detailed quote after discussing your specific needs to ensure complete transparency.</p>

<h4>Can I update my website content after it’s launched?</h4>
<p>Absolutely! Pankaj builds websites using CMS platforms like WordPress, making it easy for clients to manage and update their content after the site is live. He also provides guidance and support to help you get comfortable with updates.</p>

<h4>Does Pankaj offer ongoing support for my website?</h4>
<p>Yes, Pankaj provides ongoing maintenance and support services to keep your website secure and functional. This includes troubleshooting, updates, and performance enhancements as needed.</p>

<h4>How long does it take to complete a website design project?</h4>
<p>The project timeline varies based on its complexity and requirements. Pankaj provides an estimated timeframe after discussing your project, typically ranging from a few weeks to a couple of months.</p>

<h4>How can I get in touch with Pankaj for website design services in Vijayawada?</h4>
<p>You can reach out to Pankaj through the contact form on this website or by using the provided contact information. He is ready to discuss your project and help you build a website that aligns with your brand’s goals.</p>

          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
